import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import sites from '@config/sites.js'
import {DEFAULT_PHONE_PREFIX} from '../utils/phone-utils'

// phonePrefix is on config/sites.js — useMultiSite doesn't always expose it
const useLocalePhonePrefix = () => {
    const {locale, site} = useMultiSite()

    if (locale?.phonePrefix) {
        return locale.phonePrefix
    }

    const siteConfig = sites.find((entry) => entry.id === site?.id)
    const localeConfig = siteConfig?.l10n?.supportedLocales?.find(
        (entry) => entry.id === locale?.id || entry.alias === locale?.alias
    )

    return localeConfig?.phonePrefix || DEFAULT_PHONE_PREFIX
}

export default useLocalePhonePrefix
